import React from "react";
import { Grid, Typography, Button, Box, Link} from "@mui/material";
import { styled } from '@mui/system';
import EastIcon from '@mui/icons-material/East';
import { useTheme } from '@mui/material/styles';
// import language from "../../language";

const h1Title = "Zielona Chatka";
const pSubtitle = "Kotelnica 1, 34-405 Białka Tatrzańska";
// const buttonText = "Order Now";
const buttonText = "Zamów Teraz";
// const arrowButton = "Location";
const arrowButton = "Lokalizacja";

  // const SloganClass = styled(Box)({
  //   position: "relative",
  //   // zIndex: 2,
  //   paddingTop: "10%",
  //   left: "0%",
  //   width: '100%',
  //   "@media (max-width: 900px)": {
  //     width: '100%',
  //     height: 'auto',
  //   },
  // });

  const ArrowText = styled(Box)({
    display: "flex",
    alignItems: "center",
    marginTop: '5%',
  });


const HeroLeft = () => {
  const theme = useTheme();

    return (
      <Grid container spacing={0}>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
          sx={{
            paddingTop: '20%',
            paddingLeft: '10%',
            "@media (max-width: 900px)": {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '30%',
              paddingLeft: '0%',
            },
          }}>
          <Typography variant='customFont'>
            {h1Title}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
          sx={{
            paddingLeft: '10%',
            paddingTop: '10%',
            "@media (max-width: 900px)": {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '5%',
              paddingLeft: '0%',
            },
          }}>
          {/* <SloganClass> */}
            <Typography variant='p' >
              {pSubtitle}
            </Typography>
          {/* </SloganClass> */}
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
          sx={{
            paddingLeft: '10%',
            "@media (max-width: 900px)": {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '5%',
              paddingLeft: '0%',
            },
          }}>
          <Button type="button" href="/order" variant="primaryButton" sx={{height: "4rem", paddingLeft:'3rem', paddingRight:'3rem', marginTop: '3.75rem'}}>
              {buttonText}
          </Button>
          <ArrowText>
            <Link 
              variant="h5"
              underline="none"
              href="/location"
              sx={{
                color: theme.palette.common.black,
                paddingLeft:'2.5rem',
                "@media (max-width: 900px)": {
                  paddingLeft: '1rem',
                },
                ":hover": {
                  color: theme.palette.primary.dark,
                  bgcolor: 'transparent',
                },
                ":active": {
                  color: theme.palette.primary.dark,
                  bgcolor: 'transparent',
                }
                }}>
              {arrowButton}
            </Link>
            <EastIcon
              sx={{
                // marginLeft: '10px',
                color: theme.palette.primary.dark,
                // ":hover": {
                //   color: theme.palette.common.black,
                //   bgcolor: 'transparent',
                // },
                // ":active": {
                //   color: theme.palette.common.black,
                //   bgcolor: 'transparent',
                // }
              }}
            />
          </ArrowText>
        </Grid>

      </Grid>
    )
}

export default HeroLeft;